module.exports = __webpack_public_path__ + "static/media/27OCHA3.ca95bd3d.jpg";